export default __webpack_public_path__ + "static/media/menu.8655d0bc.svg";